import { async } from "q";
import axiosClient from "./axiosClient";

const serviceURL = "store/unit";
const UnitStoreService = {
    getUnit: async (params) => {
    const url = serviceURL + `/list-unit?page=1&limit=100`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
}

export default UnitStoreService;